import React, { useEffect } from 'react';
import styles from './LandingPage.module.css';

export default function LandingPage(props) {
  const videoSrc = "https://www.greenyellow.co.th/wp-content/uploads/2021/08/GreenYellow_solar-solutions_%E0%B9%82%E0%B8%8B%E0%B8%A5%E0%B9%88%E0%B8%B2%E0%B8%A3%E0%B9%8C%E0%B9%80%E0%B8%8B%E0%B8%A5%E0%B8%A5%E0%B9%8C-5-video.mp4";
  const imgSrc = "";

  return (
    <div className={styles.landingPageContainer}>
      {/* <video className={styles.bgVideo} autoPlay loop muted src={videoSrc} /> */}
      {/* <img className={styles.bgImage} alt="cover" src="https://www.greenyellow.co.th/wp-content/uploads/2023/10/beautiful-alternative-energy-plant-with-solar-panels-new.jpg" /> */}
      {/* <div className={styles.overlay} /> */}
      <div className={styles.textContainer}>
        <div className={styles.title}>{props.title}</div>
        <div className={styles.subtitle}>{props.subtitle}</div>
      </div>
    </div>
  );
}